import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EmailService } from 'src/app/shared/services/email.service';
import { PropertyService } from './../../../shared/services/property.service';
import { brandByExternalId_brandByExternalId_properties } from 'src/app/shared/graphql/types/brandByExternalId';
import { propertySearchFn } from 'src/app/shared/functions/propertySearchFn';
import {  NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-meeting-events',
  templateUrl: './meeting-events.component.html',
  styleUrls: ['./meeting-events.component.scss']
})
export class MeetingEventsComponent implements OnInit {
  meetingEventsForm: UntypedFormGroup;
  showSuccess: boolean;

  properties: brandByExternalId_brandByExternalId_properties[] = [];
  propertyLoading: boolean;
  propertySearchFn = propertySearchFn;

  model: NgbDateStruct;

  constructor(fb: UntypedFormBuilder, private emailService: EmailService, private propertyService: PropertyService) {
    this.meetingEventsForm = fb.group({
      firstName: new UntypedFormControl(null, Validators.required),
      lastName: new UntypedFormControl(null, Validators.required),
      propertyId: new UntypedFormControl(null, Validators.required),
      phone: new UntypedFormControl(null),
      email: new UntypedFormControl(null, Validators.required),
      arrival: new UntypedFormControl(null),
      departure: new UntypedFormControl(null),
      groupSize: new UntypedFormControl(null),
      rooms: new UntypedFormControl(null),
      additionalMsg: new UntypedFormControl(null, Validators.required)
    });
  }

  ngOnInit(): void {
    this.getBrandDetails();
  }

  getBrandDetails() {
    this.propertyLoading = true;
    this.propertyService.brand$.subscribe(res => {
      this.properties = res.properties;
      this.propertyLoading = false;
    });
  }

  onSubmit() {
    let formData = {
      name: this.meetingEventsForm.value.firstName + ' ' + this.meetingEventsForm.value.lastName,
      hotel: this.meetingEventsForm.value.hotel,
      phone: this.meetingEventsForm.value.phone,
      email: this.meetingEventsForm.value.email,
      propertyId: this.meetingEventsForm.value.propertyId,
      description: "Message from corporates and groups. Arrival: " + this.meetingEventsForm.value.arrival +
      ", departure:" + this.meetingEventsForm.value.departure +
      ", Group Size: " + this.meetingEventsForm.value.groupSize +
      ", number of rooms:" + this.meetingEventsForm.value.rooms +
      ", Additional Message:" + this.meetingEventsForm.value.additionalMsg,
      subscribe: false
    };

    this.emailService.sendEmailBookingService(formData).subscribe(data => {
      this.showSuccess = true;
    })
  }
}